import request from 'utils/request'
import { MCAXS660sendMessageRequest } from 'types/MCAXS660/MCAXS660sendMessageRequest'

export const initRequest = () =>
    request({
        url: '/MCAXS660/init',
        method: 'POST',
    })